import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  label: {
    color: theme.palette.text.primary,
    ...theme.typography.body1,
    textTransform: 'none',
  },
  startIcon: {
    marginRight: '10px',
  },
}));

function MenuButton({ startIcon, ...props }) {
  const { classes } = useStyles();
  return <Button {...props} classes={classes} startIcon={startIcon} />;
}

MenuButton.propTypes = {
  startIcon: PropTypes.node,
};

export default memo(MenuButton);
